<template>
<div class="filter-controls col-12 p-2 rounded mb-4 shadow-sm">

    <div class="filter-tags col-12 rounded">
        <span v-for="tag in selectedYears" :key="'year'+tag.year" class="filter-tag badge bg-secondary mx-1">{{ tag.year === 'unknown' ? 'unknown year' : tag.year }} <a @click.prevent="removeYearTag(tag.year)" href="#" title="Remove" class="ms-1">x</a></span>
        <span v-for="tag in selectedTags" :key="'tag'+tag.id" class="filter-tag badge bg-secondary mx-1">{{ tag.name }} <a @click.prevent="removeTagTag(tag.id)" href="#" title="Remove" class="ms-1">x</a></span>
        <span v-for="tag in selectedRarities" :key="'rarity'+tag.id" class="filter-tag badge bg-secondary mx-1">{{ tag.slug }} <a @click.prevent="removeRarityTag(tag.id)" href="#" title="Remove" class="ms-1">x</a></span>
        <!-- <span v-for="tag in selectedEditions" :key="'edition'+tag.id" class="filter-tag badge bg-secondary mx-1">{{ tag.name }} <a @click.prevent="removeEditionTag(tag.id)" href="#" title="Remove" class="ms-1">x</a></span> -->
        <span v-if="selectedSorting" :key="'sort'+selectedSorting.slug" class="filter-tag badge bg-secondary mx-1">Sort: {{ selectedSorting.name }} <a @click.prevent="removeSortTag" href="#" title="Remove" class="ms-1">x</a></span>
        <button v-if="selectedAny" @click.prevent="removeAll" class="ms-3 btn btn-sm btn-link text-primary">clear all</button>
    </div>
<div class="row">
    <div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4 mt-2">
        <div class="col-12"><strong class="text-secondary">Filters:</strong></div>
        <div class="dropdown d-inline">
            <a class="shadow-sm btn btn-light dropdown-toggle" type="button" id="filterYear" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                Years
            </a>
            <ul class="dropdown-menu" aria-labelledby="filterYear">
                <li v-for="year in years" :key="'allYears'+year.year" class="dropdown-item">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" :id="'dropdownYear'+year.year" v-model="year.selected">
                        <label class="form-check-label" :for="'dropdownYear'+year.year">{{ year.year }}</label>
                    </div>
                </li>
            </ul>
        </div>

        <div class="dropdown d-inline ms-2">
            <a class="shadow-sm btn btn-light dropdown-toggle" :class="{disabled: !allTags}" type="button" id="filterTags" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                Tags
            </a>
            <ul class="dropdown-menu" aria-labelledby="filterTags">
                <div class="px-3 py-2"><input type="search" class="form-control" placeholder="Search Tags" v-model="tagSearch"></div>
                <li v-for="tag in filteredTags.slice(0, 10)" :key="'allTags'+tag.id" class="dropdown-item">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" :id="'dropdownTags'+tag.id" v-model="tag.selected">
                        <label class="form-check-label" :for="'dropdownTags'+tag.id">{{ tag.name }}</label>
                    </div>
                </li>
                <li v-show="filteredTags.length > 10" class="text-center text-muted small">{{ filteredTags.length - 10 }} more tags</li>
            </ul>
        </div>

        <div class="dropdown d-inline ms-2">
            <a class="shadow-sm btn btn-light dropdown-toggle" type="button" id="filterRarity" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                Rarity
            </a>
            <ul class="dropdown-menu" aria-labelledby="filterRarity">
                <li v-for="rarity in rarities" :key="'allRarities'+rarity.id" class="dropdown-item">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" :id="'dropdownRarity'+rarity.id" v-model="rarity.selected">
                        <label class="form-check-label" :for="'dropdownRarity'+rarity.id">{{ rarity.name }}</label>
                    </div>
                </li>
            </ul>
        </div>

        <!-- <div class="dropdown d-inline ms-2">
            <a class="shadow-sm btn btn-light dropdown-toggle" type="button" id="filterEdition" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                Edition
            </a>
            <ul class="dropdown-menu" aria-labelledby="filterEdition">
                <li v-for="edition in editions" :key="'allEditions'+edition.id" class="dropdown-item">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" :id="'dropdownEdition'+edition.id" v-model="edition.selected">
                        <label class="form-check-label" :for="'dropdownEdition'+edition.id">{{ edition.name }}</label>
                    </div>
                </li>
            </ul>
        </div> -->
    </div>

    <div class="col-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 mt-2">
        <div class="col-12"><strong class="text-secondary">Sort:</strong></div>
        <div class="dropdown d-inline">
            <a class="shadow-sm btn btn-light dropdown-toggle" type="button" id="sorting" data-bs-toggle="dropdown" aria-expanded="false">
                {{ selectedSorting ? selectedSorting.label : (isSearching ? 'Search Relevancy' : 'Default') }}
            </a>
            <ul class="dropdown-menu" aria-labelledby="sorting">
                <li><a @click.prevent="setSort(null)" class="dropdown-item" :class="{active: !selectedSorting}" href="#">{{ isSearching ? 'Search Relevancy' : 'Default' }}</a></li>
                <li v-for="sort in sorting" :key="sort.slug"><a @click.prevent="setSort(sort.slug)" class="dropdown-item" :class="{active: sort.selected}" href="#">{{ sort.name }}</a></li>
            </ul>
        </div>
    </div>

    <div class="col mt-4 mt-md-0 d-flex align-items-end justify-content-end">
        <button @click="submitFiltered" class="btn data-apply-filters" :class="[hasChanged ? 'btn-primary text-light' : 'btn-outline-primary']">Apply Filters</button>
    </div>
</div>
</div>
</template>

<script>
export default {
    name: "FilterControls",
    props: {
        allYears: {
            type: Array,
            required: false
        },
        allTags: {
            type: Array,
            required: false,
            default: null
        },
        allRarities: {
            type: Array,
            required: false
        },
        allSorting: {
            type: Array,
            required: false
        },
        current: {
            type: Object,
            required: false
        },
        isSearching: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            years: [],
            tags: [],
            rarities: [],
            sorting: [],
            tagSearch: null,
            hasChanged: false
        }
    },
    computed: {
        selectedYears() {
            return this.years.filter(tag => tag.selected);
        },

        selectedTags() {
            return this.tags.filter(tag => tag.selected);
        },

        filteredTags() {
            if (this.tagSearch) {
                return this.tags.filter(t => t.name.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase().includes(this.tagSearch.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase().trim()));
            } else {
                return this.tags;
            }
        },

        selectedRarities() {
            return this.rarities.filter(tag => tag.selected);
        },

        selectedSorting() {
            return this.sorting.find(tag => tag.selected);
        },

        selectedAny() {
            return this.selectedYears.length || this.selectedRarities.length || this.selectedTags.length || this.selectedSorting;
        }
    },
    created() {
        this.allYears.forEach(y => {
            y.selected = this.current.years && !!this.current.years.find(cy => cy == y.year);
        });
        this.years = [...this.allYears].sort((a,b) => b.year - a.year);

        if (this.allTags) {
            this.allTags.forEach(t => {
                t.selected = this.current.tags && !!this.current.tags.find(ct => ct.id === t.id);
            });
            let tags = [...this.allTags.filter(t => t.id > 49)];
            this.tags = tags.filter((obj, index, self) => index === self.findIndex(el => el.slug === obj.slug));

            this.$watch('tags', {
                handler() {
                    this.hasChanged = true;
                },
                deep: true
            });
        }
        
        this.allRarities.forEach(r => {
            r.selected = this.current.rarity && !!this.current.rarity.find(cr => cr.id === r.id);
        });
        this.rarities = [...this.allRarities];

        this.allSorting.forEach(s => {
            s.selected = this.current.sort && this.current.sort.slug === s.slug;
            s.label = s.name.length > 10 ? s.name.slice('0', 7) + '...' : s.name;
        });
        this.sorting = [...this.allSorting];

        this.$watch('years', {
            handler() {
                this.hasChanged = true;
            },
            deep: true
        });

        this.$watch('rarities', {
            handler() {
                this.hasChanged = true;
            },
            deep: true
        });

        this.$watch('sorting', {
            handler() {
                this.hasChanged = true;
            },
            deep: true
        });
    },
    methods: {
        
        removeYearTag(tag) {
            this.years.find(y => y.year == tag).selected = false;
        },

        removeTagTag(tag) {
            this.tags.find(t => t.id == tag).selected = false;
        },

        removeRarityTag(tag) {
            this.rarities.find(r => r.id == tag).selected = false;
        },

        removeSortTag() {
            this.sorting.forEach(s => s.selected = false);
        },

        removeAll() {
            this.years.forEach(y => y.selected = false);
            this.tags.forEach(t => t.selected = false);
            this.rarities.forEach(r => r.selected = false);
            this.sorting.forEach(s => s.selected = false);
        },

        setSort(sort) {
            this.sorting.forEach(s => s.selected = s.slug === sort);
        },

        submitFiltered() {
            if (window.fathom) {
                window.fathom.trackGoal('NRMOKKGH', 0);
            }

            let url = new URL('https://' + window.location.hostname + window.location.pathname),
                years = this.selectedYears.map(y => y.year),
                tags = this.selectedTags.map(t => t.slug),
                rarity = this.selectedRarities.map(r => r.slug),
                sorting = this.selectedSorting,
                params = new URLSearchParams(window.location.search);

            if (params.has('q')) {
                url.searchParams.append('q', params.get('q'));
            }

            if (years.length > 0) {
                url.searchParams.append('years', years.join());
            }

            if (tags.length > 0) {
                url.searchParams.append('tags', tags.join());
            }

            if (rarity.length > 0) {
                url.searchParams.append('rarity', rarity.join());
            }

            if (sorting) {
                url.searchParams.append('sort', sorting.slug);
            }
            
            window.location.assign(url);
        }
        
    }
}
</script>